export default function AttachPreparationItemReportFolderDirective() {
  return {
    template: require('./attach-preparation-item-report-folder.html'),
    scope: {
      preparationItemId: '=',
      serviceId: '=',
      reportFolder: '=',
    },
    controller: 'AttachPreparationItemReportFolderController',
    controllerAs: 'attachPreparationItemReportFolderVM',
    bindToController: true,
    replace: true
  };
}
